import config from '../config';
import {fetchHelper, setToken, simulateDelay} from '../utils/requestUtils';

export async function submitLogin(username, password) {
    await simulateDelay();
    const response = await fetchHelper({
        method: "POST",
        url: "/users/login",
        reqBody:{username, password}
    })
    setToken(response)
    return
}

export async function submitLogout() {
    await simulateDelay();
    try {
        document.cookie = `jsonWebToken=${''}`;
        location.replace("/");
        setTimeout(() => document.location.reload(), 500); // Wipe out GQL cache
    } catch (err) {
        throw new Error('Failed logout.');
    }
}
